import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
declare var $: any;
import * as _ from 'lodash';
import { Sh6Service } from 'src/app/services/sh6.service';
@Component({
  selector: 'app-sh6list',
  templateUrl: './sh6list.component.html',
  styleUrls: ['./sh6list.component.css']
})
export class Sh6listComponent implements OnInit {

  public environmentSettings: any;
  isSearchDivVisible = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  deletebankdetails:any ;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  currentURL : any;
  response: boolean;
  deleteSh6Details:any;
  TodayDate: NgbDateStruct;
  dateOnWhichOptionsExcercisedModel:any;
  dateOnWhichOptionsExcercised: any;
  dateOfSpecialResolution:any;
  nameOfTheGrantee: any;
  editParticularId: any;
 
  constructor(private sh6: Sh6Service, private router: Router,private activatedRoute: ActivatedRoute,
     private commonFunction: CommonFunction,private alert: AlertComponent) {
    this.response = false;
  }
 
  ngOnInit() {
 
    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');

    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [8] }],
      dom: 'lBfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'SH 6',
          title: 'SH 6',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 5, 7],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    this.getRegisterDirectorList();
 
    this.currentURL = window.location.href;
    var haseditpermisssion : any = false;
    if(this.currentURL.includes('edit') && !environment.PSS){
        haseditpermisssion = this.commonFunction.validateURL('Director','edit');
    }
    else if(environment.PSS){
      haseditpermisssion = this.commonFunction.validateURL('Director','add');
    }
    haseditpermisssion= false;
 
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; 
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };

  }
  addsh6(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh-6','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if (directorData.length){
      this.masterDirectorList = [];
      $("#directormastersh6Table").DataTable().destroy();
      this.masterDirectorList = directorData;
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#directormastersh6Table").DataTable().columns.adjust().draw();
      }, 200);
    }
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directormastersh6Table").DataTable().columns.adjust().draw();
    });
  }
 
  getRegisterDirectorList() {
    this.registerDirectorList = [];
    this.sh6.getRegisterDirector({isSearch: false}).subscribe(registerList => {
      $("#directormastersh6Table").DataTable().destroy();
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
      // setTimeout(() => {
      //   this.dtTriggerRegisterDirector.next();
      // }, 200);
    });
  }

  confirmDelete(id) {
    this.deleteSh6Details = id;
    $("#deleteConfirm").modal('toggle');
  }

  removesh6detail(){
    this.sh6.removesh6details(this.deleteSh6Details)
    .subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        $("#directormastersh6Table").DataTable().destroy();
        this.getRegisterDirectorList();
        $("#deleteConfirm").modal('toggle');
      }
      else
      {
        this.alert.error(response.message);
      }
    });
 }

 editsh6(_id) {
  this.router.navigate(
    [{ outlets: { 'structure-outlet': ['sh-6','edit',_id]  } }],
    { relativeTo: this.activatedRoute.parent });
  // this.router.navigate(['sh6/edit/', _id]);
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOnWhichOptionsExcercised,
      toDate: this.dateOfSpecialResolution,
      name: this.nameOfTheGrantee
    }
    this.sh6.generateSh6Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }
  
  downloadDocument(id) {
    this.sh6.downloadSh6File(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.sh6.downloadSh6PdfFile(id, 'Multi');
  }
  
  doAdvSearch(){
    this.response = true;
    var searchParam =
    {
      "nameOfTheGrantee": this.nameOfTheGrantee,
      "dateOnWhichOptionsExcercised":this.setDate(this.dateOnWhichOptionsExcercised),
      "dateOfSpecialResolution":this.setDate(this.dateOfSpecialResolution),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#directormastersh6Table").DataTable().destroy();
    this.sh6.getRegisterDirector(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
    
  }

  clearAdvSearch(){
    this.nameOfTheGrantee = '';
    this.dateOnWhichOptionsExcercised='';
    this.dateOfSpecialResolution='';
    $("#directormastersh6Table").DataTable().destroy();
    this.doAdvSearch();
    this.response = false;
   
  }

}
 


